import SectionHeader from '../Common/SectionHeader';
import { Icon } from '@iconify/react';
import ToolTip from '../Common/Tooltip';
import { useDispatch, useSelector } from 'react-redux';
import { MAXIMIZE_OR_MINIMIZE_IMAGE_SECTION } from '../../../store/actions';
import _ from 'lodash';
import { useEffect, useRef, useState } from 'react';
import { ClipLoader } from 'react-spinners';
import { Row, Col } from 'react-bootstrap';
import ImagePopup from './ImagePopup';
import ReactImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/scss/image-gallery.scss"
import "react-image-gallery/styles/css/image-gallery.css"
import { IMAGE_OPTIONS_TYPE } from '../../../Common/constants';

const ImageCarousel = props => {

	const imageRef = useRef();
    const dispatch = useDispatch();
    const isEditOngoing = useSelector(state => state.equipment.isEditOngoing);
    const isComponentLoading = useSelector(state => state.equipment.componentLoading);
	const currentImages = useSelector(state =>
		{
			return props?.target === IMAGE_OPTIONS_TYPE[0] ?
				state.equipment.equipmentPictures
					:
				{
					"component" : state.equipment.selectedComponent?.componentPictures,
					"label" : state.equipment.selectedComponent?.labelPictures
				};
		},
		(oldState, newState) => _.isEqual(oldState, newState)
	);
	const currentComponentId = useSelector(state => state.equipment?.selectedComponent?.id);

	const [utils, setUtils] = useState({ images: {}, selectedImage: "", selectedImageId: "", index: 0, currentComponentId: "" });

	useEffect(() => {
		if(!_.isEmpty(currentImages) && !props.loading) {
			let images = [], imgObj = {};
			if(props?.target === IMAGE_OPTIONS_TYPE[1]) {
				imgObj = { ...currentImages?.component, ...currentImages?.label };
			}
			else {
				imgObj = currentImages;
			}
			Object.keys(imgObj).forEach((id) => {
				images.push({
					originalAlt: "Image Not Found",
					originalTitle: id,
					original: imgObj[id],
					originalHeight: "200px",
					originalWidth: "200px"
				});
			});
			setUtils({
				...utils, images: images, currentComponentId: currentComponentId,
				index: props?.target === IMAGE_OPTIONS_TYPE[1] && currentComponentId !== utils.currentComponentId ? 0 : utils.index
			});
		}
		else {
			setUtils({ ...utils, images: {}, index: 0 });
		}
	}, [currentImages, props.loading, currentComponentId]);

	const returnNavigationArrows = (direction, callBack) => 
		<div onClick={() => callBack()} className={`arrow-container InfiniteCarouselArrow image-carousel-${direction}`}>
			<div className="arrow-circle">
				<b>
					{ _.isEqual(direction, 'left') ?
						<div className="arrow-symbol">&#60;</div>
							:
						<div className="arrow-symbol">&#62;</div>
					}
				</b>
			</div>
		</div>

	const setSelectedImage = (id) => {

		let imgLink = props.target === IMAGE_OPTIONS_TYPE[0] ?
			currentImages[id]
				:
			!_.isEmpty(currentImages?.component[id]) ?
				currentImages.component[id]
					:
				currentImages.label[id];
		setUtils({ ...utils, selectedImage: imgLink, selectedImageId: id });
	}

    return (
		<>
			<SectionHeader
				title={props.title}
				headerComponent={
					<ToolTip toolTipKey={'Maximize'} toolTipValue={'Maximize'}
						overlayComponent={
							<Icon
								onClick={() => dispatch({ type: MAXIMIZE_OR_MINIMIZE_IMAGE_SECTION, payload: props.target })}
								className={`mr-3 cursor-pointer ${(isEditOngoing || isComponentLoading) && "disable-click text-color-grey"}`}
								icon={'feather-maximize'}
							/>
						}
					/>
				}
			/>
			<div style={{ borderBottom: '2px solid #075978' }} className="p-1">
			{
				props.loading ?
					<Row className='text-center w-100 mx-0 p-5 my-4'>
						<Col sm={12} xs={12} lg={12} md={12} xl={12}>
							<ClipLoader color='#075978' />
						</Col>
					</Row>
						:
					<>
						{
							!_.isEmpty(utils.images) ?
								<ReactImageGallery
									showIndex={true} startIndex={utils.index} ref={imageRef}
									renderLeftNav={(onClick) => returnNavigationArrows("left", () => onClick())}
									renderRightNav={(onClick) => returnNavigationArrows("right", () => onClick())}
									onSlide={() => setUtils({ ...utils, index: imageRef?.current?.getCurrentIndex() })}
									onClick={(e) => setSelectedImage(e.target.title)}
									disableKeyDown={true} showThumbnails={false}
									showFullscreenButton={false} useTranslate3D={true}
									showPlayButton={false} items={utils.images}
								/>
									:
								<div className="equipment-list-flex-box font-weight-bold" style={{ height: '200px', justifyContent: 'center' }}>
									NO IMAGE FOUND
								</div>
						}
						{
							!_.isEmpty(utils.selectedImage) &&
								<ImagePopup target={props.target} imageId={utils.selectedImageId}
									image={utils.selectedImage} closePopup={() => setUtils({ ...utils, selectedImage: "" })}
								/>
						}
					</>
			}
			</div>
		</>
	);
};

export default ImageCarousel;